import React, { useState } from 'react';
import _ from 'lodash';
import useTranslation from 'Hooks/useTranslation';
import { NO_EMPTY_NO_EMPTY_SPACES } from 'Constants/Regex';
import TextInput from 'Components/FormComponents/TextInput';
import { ResponseContainer, inputLabel } from './style';

function FreeResponse({ question, formData, setFormData, setUnchanged, positionQuestion }) {
  const { t2 } = useTranslation('EditCourse');
  const [answerData, setAnswerData] = useState(question.answers[0]);

  const onAnswerBlur = event => {
    const formDataCopy = _.cloneDeep(formData);
    formDataCopy.questions[positionQuestion].answers[0] = {
      ...answerData,
      response: event.target.value,
      isCorrect: true,
    };

    if (answerData.response.match(NO_EMPTY_NO_EMPTY_SPACES)) {
      setFormData({
        ...formDataCopy,
        errors: {
          ...formDataCopy.errors,
          [`question-${question.id}_answer-${question.answers[0].id}`]: t2('FormErrorEvaluationAnswer'),
        },
      });

      return;
    }

    delete formDataCopy.errors[`question-${question.id}_answer-${question.answers[0].id}`];

    setFormData({ ...formDataCopy });
  };

  const handleChange = event => {
    setAnswerData({
      ...answerData,
      [event.target.name]: event.target.value,
    });
    setUnchanged(false);
  };

  return (
    <ResponseContainer>
      <div style={inputLabel}>{t2('CorrectResponse')}</div>
      <TextInput
        name="response"
        label={t2('Answer')}
        color="MexlogGreen"
        value={answerData?.response}
        onChange={handleChange}
        multiline
        minRows={3}
        onBlur={onAnswerBlur}
        errortext={formData?.errors[`question-${question.id}_answer-${question.answers[0].id}`]}
      />
    </ResponseContainer>
  );
}

export default FreeResponse;
